<template>
  <bsp-dialog :title="$t('cost.invoice024')" :dialogVisible.sync="visible" @closeButton="closeDialog" width="1100px"><!-- 维护票据信息 -->
    <template #body v-loading="loading">
      <div class="gridHead">
        <el-form ref="mainForm" :model="mainForm" :rules="rules" label-width="120px" @submit.native.prevent>
          <bsp-collapsible-module :title="$t('cost.invoice049')" :content-style="{}"><!-- 票据文件 -->
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice025')" prop="receiptType"><!-- 票夹类型 -->
                  <bsp-dicts-select v-model="mainForm.receiptType" :select-value.sync="mainForm.receiptType" dic-num="8052" @selectChange="receiptTypeChange"  :disabled="optType != 'add'" ></bsp-dicts-select>
                </el-form-item>
              </el-col>
              <el-col :span="16" v-show="!params.id && mainForm.receiptType == '80520001'" style="padding-left: 10px;">
                <span style="color:red;">{{$t('cost.invoice063')}}</span><!-- 新增国内制式发票，建议优先使用AI智能之别票据，支持一键上传、智能识别，简化录入操作！ -->
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('cost.invoice026')" prop="attachId"><!-- 上传票据 -->
                  <div class="file-list" v-show="!!invoiceFile.attachmentId">
                    <el-link :underline="false" @click="viewFile(invoiceFile)">{{invoiceFile.fileName}}</el-link>
                    <svg class="icon file-ope" aria-hidden="true" @click="deleteImg(index)" v-show="optType == 'add'">
                      <use xlink:href="#icon-guanbi"></use>
                    </svg>
                  </div>
                  <el-upload
                    ref="upload"
                    action="#"
                    :before-upload="beforeUpload"
                    accept="*"
                    :show-file-list="false"
                    :http-request="function (file) { return fileChange(file)}"
                    v-show="!invoiceFile.attachmentId"
                  >
                    <el-button slot="trigger" type="primary" v-show="!invoiceFile.attachmentId">{{$t('cost.invoice050')}}</el-button><!-- 选择文件 -->
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </bsp-collapsible-module>
          <bsp-collapsible-module :title="$t('cost.invoice027')" :content-style="{}"><!-- 票据信息 -->
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice048')" prop="invoiceType"><!-- 票据类型 -->
                  <bsp-dicts-select v-model="mainForm.invoiceType" :select-value.sync="mainForm.invoiceType" :options-list="invoiceList" @selectChange="vatTypeChange" :disabled="optType == 'view' || (optType == 'edit' && mainForm.invoiceId ) "></bsp-dicts-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice028')"><!-- 费用项目 -->
                  {{ mainForm.projectName || '--' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice047')" prop="invoiceHm"><!-- 票据号码 -->
                  <el-input v-model="mainForm.invoiceHm" :disabled="optType == 'view'" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice029')" prop="invoiceCode"><!-- 票据代码 -->
                  <el-input v-model="mainForm.invoiceCode" :disabled="optType == 'view'" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice030')" prop="invoiceDate"><!-- 开票日期 -->
                  <el-date-picker v-model="mainForm.invoiceDate" type="date" value-format="yyyy-MM-dd" @change="invoiceDateChange" :disabled="optType == 'view'"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="mainForm.invoiceType == '10420014' || mainForm.invoiceType == '10420016'">
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice031')" prop="startDate"><!-- 行程开始日期 -->
                  <el-date-picker v-model="mainForm.startDate" type="date" value-format="yyyy-MM-dd" @change="startDateChange" :disabled="optType == 'view'"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice032')" prop="endDate"><!-- 行程结束日期 -->
                  <el-date-picker v-model="mainForm.endDate" type="date" value-format="yyyy-MM-dd" @change="endDateChange" :disabled="optType == 'view'"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
            <el-row v-if="mainForm.invoiceType == '10420014' || mainForm.invoiceType == '10420016'">
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice033')" prop="startAddr"><!-- 出发地址 -->
                  <el-input v-model="mainForm.startAddr" :disabled="optType == 'view'" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice034')" prop="endAddr"><!-- 目的地址 -->
                  <el-input v-model="mainForm.endAddr" :disabled="optType == 'view'" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice035')" prop="currency"><!-- 币种 -->
                  <bsp-dicts-select v-model="mainForm.currency" :select-value.sync="mainForm.currency" dic-num="1009" @selectChange="currencyChange" :disabled="optType == 'view'"></bsp-dicts-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice036')" prop="exchangeRate"><!-- 汇率 -->
                  <el-input-number v-model="mainForm.exchangeRate"  controls="true" precision="4" placeholder="汇率" min="-0.1" max="999999999.1" @change="exchangeRateChange" :disabled="optType == 'view'"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice037')" prop="includeTax"><!-- 人民币金额 -->
                  <el-input v-model="mainForm.includeTax" placeholder="0.00"  readonly :disabled="optType == 'view'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice038')" prop="fmoney"><!-- 含税金额 -->
                  <el-input-number v-model="mainForm.fmoney" precision="2"  min="-0.001" max="999999999.001" @change="fmoneyChange" :disabled="optType == 'view'"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice039')" prop="excludeTax"><!--  不含税金额-->
                  <el-input-number v-model="mainForm.excludeTax" precision="2" min="-0.001" max="999999999.001" @change="excludeTaxChange" :disabled="optType == 'view'"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice040')" prop="vatMoney"><!-- 税额 -->
                  <el-input-number v-model="mainForm.vatMoney" precision="2" min="-0.001" max="999999999.001" @change="vatMoneyChange" :disabled="optType == 'view'"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item :label="$t('cost.invoice041')" prop="buyerName"><!-- 购买方名称 -->
                  <el-input v-model="mainForm.buyerName" :disabled="optType == 'view'" maxlength="150"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice042')" prop="buyerCode"><!-- 购买方税号 -->
                  <el-input v-model="mainForm.buyerCode" :disabled="optType == 'view'" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('cost.invoice043')" prop="remark" class="form-item-content-auto"><!-- 备注 -->
                  <el-input type="textarea" v-model="mainForm.remark" :disabled="optType == 'view'" maxlength="150"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="mainForm.msg">
                <el-form-item :label="$t('cost.invoice044')" class="form-item-content-auto"><!-- 提示信息 -->
                  <el-alert type="error" :title="mainForm.msg" :closable="false"></el-alert>
                </el-form-item>
              </el-col>
            </el-row>
          </bsp-collapsible-module>
<!--          <el-row>-->
<!--            <el-col inline :span="8" style="padding: 0 0 10px 20px;">-->
<!--              <span style="font-size: 18px; font-weight: bold;">票据明细</span>-->
<!--            </el-col>-->
<!--            <el-col :span="16">-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-col :span="12" style="border: 1px solid #999999;text-align: center;">-->
<!--              货物或应税劳务、服务名称-->
<!--            </el-col>-->
<!--            <el-col :span="4" style="border: 1px solid #999999;text-align: center;">-->
<!--              金额-->
<!--            </el-col>-->
<!--            <el-col :span="2" style="border: 1px solid #999999;text-align: center;">-->
<!--              税率-->
<!--            </el-col>-->
<!--            <el-col :span="4" style="border: 1px solid #999999;text-align: center;">-->
<!--              税额-->
<!--            </el-col>-->
<!--            <el-col :span="2" style="border: 1px solid #999999;text-align: center;">-->
<!--              操作-->
<!--            </el-col>-->
<!--          </el-row>-->

<!--          &lt;!&ndash;        <el-row>&ndash;&gt;-->
<!--          &lt;!&ndash;          <el-col :span="12">&ndash;&gt;-->

<!--          &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--          &lt;!&ndash;          <el-col :span="12">&ndash;&gt;-->

<!--          &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--          &lt;!&ndash;        </el-row>&ndash;&gt;-->


        </el-form>
      </div>
      <!-- 没有实质的用处，解决页面不刷新-->
      <div v-show="false">
        <div v-for="ff in fileListRefresh" :key="ff">{{ff}}</div>
      </div>
    </template>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{$t('cost.invoice045')}}</el-button><!-- 返 回 -->
      <el-button type="primary" @click="saveCloudInvoiceFolder('confirm')" v-show="optType != 'view'">{{$t('cost.invoice046')}}</el-button><!-- 保存并确认 -->
      <!--        <el-button type="default" @click="saveCloudInvoiceFolder('save')" style="margin-left: 30px;" v-show="optType != 'view'">保 存</el-button>-->

    </div>
  </bsp-dialog>
</template>

<script>
import bspGrid from "@/components/bsp/bsp-grid/grid2";
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import BspDictsSelect from '@/components/bsp/bsp-dicts-select/bsp-dicts-select'
import BspCollapsibleModule from '@/components/bsp/bsp-collapsible-module/bsp-collapsible-module'
import {getDictsListBySetId} from '@/api/sys/code'
import { getNowFormatDate} from "@/util/date_format"
import {getCloudCostDetailMobileById, saveCloudInvoiceFolder, updateCloudInvoiceFolderApprove} from "@/api/cost/cost";
import { uploadFile, downloadQiniuFile } from "@/api/sys/sys";
import { getUserCusList, getUserCusListZz, getAllCusList} from "@/api/sys/cus";
import { downloadFile } from '@/util/util'
import {mapGetters} from 'vuex';

export default {
  name: "invoiceFolderEdit",
  components: { BspDictsSelect, BspDialog, BspCollapsibleModule },
  props:{
    params: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  data() {
    return {
      handlerOptParam:{},
      mainForm:{
        receiptType: '80520002',
        currency: "10091001",
        exchangeRate: 1,
        invoiceType: '10420023',
        invoiceTypeTxt: '境外票据',
        fmoney: 0,
        excludeTax: 0,
        vatMoney: 0,
      },
      optParam : {},
      userId:'', //用户id
      cdmId:"",
      optType: 'add', //页面操作类型

      from : "",
      parentFrom:"",
      tableDatas: [],
      opt:"add",//新增、编辑，目前为材质只支持新增
      searchParams: {},
      demoLoading: false,
      loadingImport: false,
      loadingBtn: false,
      receiptTypeReadonlyFlag: false,
      invoiceFile: {
        attachmentId: '',
        fileName: '',
      },
      visible: false,
      msg:"",
      reflashFlag : false,
      invoiceListCh: [
        {codeItemId:'10420005',codeItemName:'增值税专票（纸质）'},
        {codeItemId:'10420006',codeItemName:'增值税电子专票'},
        {codeItemId:'10420010',codeItemName:'增值税普票（纸质）'},
        {codeItemId:'10420011',codeItemName:'增值税电子普票'},
        {codeItemId:'10420013',codeItemName:'增值税卷票'},
        {codeItemId:'10420014',codeItemName:'火车票'},
        {codeItemId:'10420015',codeItemName:'定额票'},
        {codeItemId:'10420016',codeItemName:'飞机票(行程单)'},
        {codeItemId:'10420017',codeItemName:'出租车票'},
        {codeItemId:'10420018',codeItemName:'客运发票'},
        {codeItemId:'10420019',codeItemName:'普通发票'}
      ],//国内票据
      invoiceListForeign:[
        {codeItemId:'10420012',codeItemName:'收据'},
        {codeItemId:'10420022',codeItemName:'门票'},
        {codeItemId:'10420023',codeItemName:'境外发票'},
        {codeItemId:'10420024',codeItemName:'财政票据'}
      ],//其他票据
      invoiceList:[],
      rules: {
        receiptType: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.invoice025'), trigger: 'change' } //请选择 票夹类型
        ],
        attachId: [
          { required: true, message: this.$t('cost.invoice053'), trigger: 'change' } //请上传文件
        ],
        invoiceType: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.invoice048'), trigger: 'change' } //请选择票据类型
        ],
        invoiceHm: [
          { required: true, message: this.$t('cost.invoice052') + this.$t('cost.invoice047'), trigger: 'blur' } //请填写票据号码
        ],
        invoiceDate: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.invoice030'), trigger: 'change' } //请选择开票日期
        ],
        startDate: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.invoice031'), trigger: 'change' } //请选择行程开始日期
        ],
        startAddr: [
          { required: true, message: this.$t('cost.invoice052') + this.$t('cost.invoice033'), trigger: 'blur' } //请填写始发地
        ],
        endAddr: [
          { required: true, message: this.$t('cost.invoice052') + this.$t('cost.invoice034'), trigger: 'blur' } //请填写目的地
        ],
        currency: [
          { required: true, message: this.$t('cost.invoice051') + this.$t('cost.invoice035'), trigger: 'change' } //请选择币种
        ],
        exchangeRate: [
          { required: true, message: this.$t('cost.invoice052') + this.$t('cost.invoice036'), trigger: 'blur' } //请填写汇率
        ],
        fmoney: [
          { required: true, message: this.$t('cost.invoice052') + this.$t('cost.invoice038'), trigger: 'change' }//请填写含税金额
        ],
        vatMoney: [
          { required: true, message: this.$t('cost.invoice052') + this.$t('cost.invoice040'), trigger: 'change' } //请填写税额
        ],
      },
    };
  },
  watch: {
    // startDate(val) {
    //   this.$set(this.mainForm, "endDate", val);
    // }
  },
  created() {
    //this.init();
  },
  mounted(){
    // console.log("批次号m",this.billBatch)
  },
  methods: {
    //初始化仓库
    init() {
      this.optType = this.params.opt;
      if(this.params.id){
        this.getCloudCostDetailMobileById(this.params.id);
      }else{
        this.$set(this, "invoiceList", this.invoiceListForeign);
      }

    },
    submitForm (optType) {
      // console.log(this.requestFieldList);
      // console.log(this.responseFieldList);

      //校验必填
      this.$refs['mainForm'].validate((valid) => {
        if (valid) {

          //如果是预约，判断预约日期是否可用
          if(this.mainForm.tdType == '80430001' && optType == '80450002' && this.userTdRole != 'BEL'){
            let params = {
              searchParams : {
                endTime : this.mainForm.endTime,
                accountMonth : this.mainForm.accountMonth,
                cusId : this.mainForm.cusId
              }
            }

            checkReserve(params)
              .then(res => {
                let result = res.data;
                if (result.code == 0) {
                  let flag = result.data.flag;
                  if(flag != "true"){
                    this.$message.error(result.data.msg);
                    this.$set(this.mainForm,"endTime", '');
                  }else{
                    this.doSubmit(optType);
                  }
                } else {
                  this.$message.error(result.msg);
                }
              })
              .catch(error => {
                this.demoLoading = false;
                if(error.data.msg){
                  this.$message.error(error.data.msg);
                }else{
                  this.$message.error(error);
                }
              })
          }else if(optType == '80450004' ||optType == '80450008'){
            let params = {
              searchParams : {
                endTime : this.mainForm.endTime,
                handoverTime : this.mainForm.handoverTime
              }
            }
            let that = this;
            checkHandoverTime(params)
              .then(res => {
                let result = res.data;
                if (result.code == 0) {
                  let flag = result.data.flag;
                  if(flag == "0"){
                    //没问题直接放过
                    that.doSubmit(optType);
                  }else{
                    //有问题 提示
                    that.$confirm(
                      result.data.msg,
                      '提示',
                      {
                        type: 'warning'
                      }
                    ).then(function(){
                      that.$set(that.mainForm,"endTime", result.data.endTimeNew);
                      that.mainForm.endTimeMsg = result.data.msg;
                      that.doSubmit(optType);
                    }).then((data) => {
                      //取消操作
                    }).catch(function (err) {
                      //捕获异常
                    });

                  }
                } else {
                  this.$message.error(result.msg);
                }
              })
              .catch(error => {
                this.demoLoading = false;
                if(error.data.msg){
                  this.$message.error(error.data.msg);
                }else{
                  this.$message.error(error);
                }
              })
          }else{
            this.doSubmit(optType);
          }

        }else{
          this.$message.warning(this.$t('cost.invoice054'));//请确认必填项信息是否已经完整录入！
        }
      });

    },
    getCloudCostDetailMobileById(id) {
      let params = {
        searchParams : {
          id: id,
        }
      }

      getCloudCostDetailMobileById(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$set(this, "mainForm", result.data.invoiceBO);

            if(!this.mainForm.fmoney){
              this.$set(this.mainForm, "fmoney", result.data.invoiceBO.includeTax);
            }

            if(this.mainForm.receiptType == "80520001"){
              this.$set(this, "invoiceList", this.invoiceListCh);
            }else{
              this.$set(this, "invoiceList", this.invoiceListForeign);
            }

            if(result.data.attachBO){
              this.$set(this, "invoiceFile", result.data.attachBO);
            }else{
              this.$set(this, "invoiceFile", {
                  attachmentId: this.mainForm.attachId,
                  fileName: this.$t('cost.invoice055')  //未查询到附件，请联系系统运维！
              });
            }
            //this.$set(this.mainForm, "fmoney", result.data.invoiceBO.includeTax);

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    saveCloudInvoiceFolder(optType) {

      if(this.mainForm.invoiceType != '10420014' && this.mainForm.invoiceType != '10420016'){
        this.$set(this.mainForm, "startDate", this.mainForm.invoiceDate);
        this.$set(this.mainForm, "endDate", this.mainForm.invoiceDate);
      }


      this.$refs['mainForm'].validate((valid) => {
        if (valid) {

          this.$set(this.mainForm, "attachId", this.invoiceFile.attachmentId);
          let params = {
            mainForm : this.mainForm
          }
          var that = this;
          saveCloudInvoiceFolder(params)
            .then((response) => {
              that.demoLoading = false;
              let result = response.data;
              if(result.code == '0'){
                that.reflashFlag = true;
                if(!that.mainForm.id){
                  that.$set(that.mainForm, "id", result.data.id);
                }
                that.$message.success(that.$t('homepage.txt028')); //操作成功
                that.$set(that.mainForm, "msg", result.data.warnMsg);
                if(optType == "confirm"){
                  if(that.mainForm.msg){
                    that.$confirm(
                      this.$t('cost.invoice056') + '[' + that.mainForm.msg + ']，' + this.$t('cost.invoice057'), //票据还存在异常  是否依旧确认票据！
                        this.$t("homepage.txt017"), //提示
                      {
                        type: 'warning'
                      }
                    ).then(function(){
                      that.saveCloudInvoiceFolderApprove();
                    }).then((data) => {
                      //取消操作
                    }).catch(function (err) {
                      //捕获异常
                    });
                  }else{
                    that.saveCloudInvoiceFolderApprove();
                  }
                }
              }else{
                this.$message.success(result.msg);
              }
            })
            .catch(error => {
              that.demoLoading = false;
              console.log("error", error)
              that.$message.error(that.$t('homepage.txt024'));//请求异常！
            });

        }else{
          this.$message.warning(this.$t('cost.invoice054'));//请确认必填项信息是否已经完整录入！
        }
      });

    },
    saveCloudInvoiceFolderApprove() {
      this.$set(this.mainForm, "opt", "approve");
      let params = {
        mainForm : this.mainForm
      }

      updateCloudInvoiceFolderApprove(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.reflashFlag = true;
            this.$message.success(this.$t('cost.invoice058')); //确认成功
            this.$emit('reload');
            this.clearForm();
            this.visible = false;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error("请求异常！");
        });

    },
    exchangeRateChange(val){
      var includeTax = val * this.mainForm.fmoney;
      this.$set(this.mainForm,"includeTax", parseFloat(includeTax).toFixed(2));
    },
    fmoneyChange(val){
      var includeTax = val * this.mainForm.exchangeRate;
      this.$set(this.mainForm,"includeTax",  parseFloat(includeTax).toFixed(2));

      if(this.mainForm.vatMoney == 0){
        this.$set(this.mainForm,"excludeTax", val);
      }else{
        var excludeTax = val - this.mainForm.vatMoney;
        this.$set(this.mainForm,"excludeTax", parseFloat(excludeTax).toFixed(2));
      }

    },
    excludeTaxChange(val){
        if(!val && val != 0){
          return;
        }

        if(this.mainForm.fmoney == 0){
          var fmoney =  this.mainForm.vatMoney + val;
          var includeTax = fmoney * this.mainForm.exchangeRate;
          this.$set(this.mainForm,"fmoney", parseFloat(fmoney).toFixed(2));
          this.$set(this.mainForm,"includeTax", parseFloat(includeTax).toFixed(2));
        }else{
          var vatMoney = this.mainForm.fmoney - val;
          this.$set(this.mainForm,"vatMoney", parseFloat(vatMoney).toFixed(2));
        }
    },
    vatMoneyChange(val){
      if(!val && val != 0){
        this.$set(this.mainForm,"vatMoney", 0);
        return;
      }

      if(this.mainForm.fmoney == 0 && this.mainForm.excludeTax == 0){
      }else if(this.mainForm.fmoney == 0 && this.mainForm.excludeTax != 0){
        var fmoney =  this.mainForm.excludeTax + val;
        var includeTax = fmoney * this.mainForm.exchangeRate;
        this.$set(this.mainForm,"fmoney", parseFloat(fmoney).toFixed(2));
        this.$set(this.mainForm,"includeTax", parseFloat(includeTax).toFixed(2));
      }else{
        var excludeTax =  this.mainForm.fmoney - val;
        this.$set(this.mainForm,"excludeTax", parseFloat(excludeTax).toFixed(2));
      }
    },
    doSubmit(optType){
      if(this.mainForm.appliIdNew != null && this.userId != this.mainForm.appliIdNew){
        for(var i = 0; i < this.touchingPersonList.length; i++){
          if(this.touchingPersonList[i].codeItemId == this.mainForm.appliIdNew){
            this.mainForm.appliNameNew = this.touchingPersonList[i].codeItemName;
          }
        }
      }

      var data = {
        params : {
          saveType : "add",
          optType : optType,
        },
        mainForm : this.mainForm,
        requestList : this.requestFieldList,
        responseList : this.responseFieldList,
      };

      // if(this.tableDatas == null || this.tableDatas.length == 0){
      //   this.$message.error("请先添加出库商品后再进行操作");
      //   return;
      // }

      this.demoLoading = true;

      saveTaskDispatch(data)
        .then(res => {
          this.demoLoading = false;
          //console.log(res);
          var code = res.data.code;
          if(code == "0"){
            this.$message.success(this.$t('homepage.txt028')); //操作成功
            this.doGoBack();
          }else{
            this.$message.error(res.data.msg);
          }
          // let result = res.data;
          // if (result.code == 0) {
          //   this.$message.success('保存成功');
          //   if(this.from == "storageDetailList"){
          //     this.$router.push({path:'/inventory/storageDetailList'});
          //   }else if(this.from == "batchDetailList"){
          //     var optParam = {
          //       itemId: this.itemId,
          //       storageId: this.storageId,
          //       storageName: this.storageName,
          //       from: this.parentFrom,
          //     };
          //     this.$router.push({path:'/inventory/batchDetailList',query: optParam});
          //   }
          // } else {
          //   this.$message.error(result.msg);
          // }
        })
        .catch(error => {
          this.demoLoading = false;
          if(error.data.msg){
            this.$message.error(error.data.msg);
          }else{
            this.$message.error(error);
          }
        })
    },
    receiptTypeChange(val) {
      // if(this.mainForm.receiptType == '80520002'){
      //   this.$set(this.mainForm, "invoiceType", "10420012");
      // }
      this.$set(this.mainForm, "invoiceType", null);
      this.$set(this.mainForm, "invoiceTypeTxt", null);

      if(val == "80520001"){
        this.$set(this, "invoiceList", this.invoiceListCh);
      }else{
        this.$set(this, "invoiceList", this.invoiceListForeign);
      }

    },
    vatTypeChange(val){
      console.log(this.dicts.codeMap)
      console.log(this.dicts.codeMap[val])
      this.$set(this.mainForm, "invoiceTypeTxt", this.dicts.codeMap[val]);
    },
    closeDialog () {
      if(this.optType == 'view'){
        this.clearForm();
        this.visible = false;
        return;
      }
      const that = this;
      this.$confirm(
          this.$t("cost.invoice059"), //是否放弃当前操作
          this.$t("homepage.txt017"), //提示
        {
          type: 'warning'
        }
      ).then(function(){
        //确认操作
        if(that.reflashFlag){
          that.$emit('reload');
        }
        that.clearForm();
        that.visible = false;
      }).then((data) => {
        //取消操作
      }).catch(function (err) {
        //捕获异常
      });

    },
    clearForm(){
      this.$set(this, "mainForm", {
        receiptType: '80520002',
        currency: "10091001",
        exchangeRate: 1,
        invoiceType: '10420010',
        invoiceTypeTxt: '增值税普票',
        fmoney: 0,
        excludeTax: 0,
        vatMoney: 0,
      });
      this.$set(this, "invoiceFile", {
        attachmentId: '',
        fileName: '',
      });
      this.$refs.mainForm.resetFields();
    },
    handleGoBack(){
      const that = this;
      if(this.optType != 'view'){
        this.$confirm(
            this.$t("cost.invoice059"), //是否放弃当前操作
            this.$t("homepage.txt017"), //提示
          {
            type: 'warning'
          }
        ).then(function(){
          //确认操作
          // if(that.from == "storageDetailList"){
          //   that.$router.push({path:'/inventory/storageDetailList'});
          // }else if(that.from == "batchDetailList"){
          //   var optParam = {
          //     itemId: that.itemId,
          //     storageId: that.storageId,
          //     storageName: that.storageName,
          //     from: that.parentFrom,
          //   };
          //   that.$router.push({path:'/inventory/batchDetailList',query: optParam});
          // }
          that.doGoBack();
        }).then((data) => {
          //取消操作
        }).catch(function (err) {
          //捕获异常
        });
      }else{
        this.doGoBack();
      }

    },
    doGoBack(){
      if(this.from == "platform"){
        this.$router.push({path:'/index'});
      }else if(this.from == "glCusList"){
        this.$router.push({path:'/taskDispatch/glCusList'});
      } else if (this.from == 'backendList') {
        this.$router.go(-1)
      } else{
        var param = {
          beCreateFlag : this.$route.query.beCreateFlag,
          pagerConfig : this.$route.query.pagerConfig,
          searchForm : this.$route.query.searchForm
        }
        //console.log("goback");
        //console.log(param);
        this.$router.push({path:'/taskDispatch/taskList', query: param});
      }
    },
    // 上传前处理
    beforeUpload(file) {
      if(this.mainForm.receiptType == null || this.mainForm.receiptType == ''){
        this.$message.error(this.$t("cost.invoice060"));//请先选择票据类型再上传附件!
        return false;
      }

      const isLt20M = file.size / 1024 / 1024 < 20;
      if (file.size <= 0){
        this.$message.error(this.$t("cost.invoice061")); //导入文件为空，请重新选择正确的文件上传!
        return false;
      }
      if (!isLt20M) {
        this.$message.error(this.$t("cost.invoice062") + ' 20MB!'); //上传文件大小不能超过
        // this.$Loading.close();
        return isLt20M;
      }

      // var fileNamesArr = file.name.split(".");
      // var fileType = fileNamesArr[fileNamesArr.length - 1];
      // if(".pdf,.png,.jpg,.jpeg,.gif,".indexOf("."+fileType+",") == -1){
      //   this.$message.error('不支持['+fileType+']类型的文件!');
      //   return false;
      // }
      // this.$Loading.full();
      return true;
    },
    // 上传文件
    fileChange(file) {

      let _this = this
      let fileName = file.file.name
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = function() {
        let base64Str = this.result;
        let startNum = (base64Str.indexOf("base64,")) * 1 + 7;
        let baseStr = base64Str.slice(startNum);

        let params = {
          mainForm : {
            fileName : fileName,
            baseStr : baseStr,
          }
        }

        uploadFile(params)
          .then((response) => {
            this.demoLoading = false;
            let result = response.data;
            if(result.code == '0'){
              _this.invoiceFile = result.data;
              _this.$set(_this.mainForm, "attachId", _this.invoiceFile.attachmentId);
              //_this.fileListRefresh.push(result.data); //没有实质的用处，解决页面不刷新
            }else{
              this.$message.success(result.msg);
            }
          })
          .catch(error => {
            this.demoLoading = false;
            console.log("error", error)
            this.$message.error(this.$t('homepage.txt024'));//请求异常！
          });

        // fileList.push({
        //   fileName : fileName,
        //   baseStr : baseStr
        // });
        // _this.fileListRefresh.push({fileName:fileName}); //没有实质的用处，解决页面不刷新
      }
    },
    deleteImg(index){
      var that = this;
      this.$confirm(this.$t('homepage.txt022')+'“'+ that.invoiceFile.fileName+'”?', this.$t("homepage.txt017"), { //您确定要删除文件  提示
        confirmButtonText: this.$t("homepage.txt018"), //确认
        cancelButtonText: this.$t("homepage.txt019"),//取消
        type: 'warning'
      }).then(() => {
        that.invoiceFile = {attachmentId: ''};
        that.$set(that.mainForm, "attachId", "");
        //that.fileListRefresh.push({fileName:index})
      }).catch(() => {
      });
    },
    download(file){
      this.demoLoading = true;
      let params = {
        mainForm : {attachmentId : file.attachmentId}
      }

      downloadQiniuFile(params)
        .then((res) => {
          this.demoLoading = false;
          downloadFile(res);
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    viewFile(file){
      window.open('/api/sys/viewAttachFile?fileId='+ file.attachmentId, '_blank')
    },
    //===============================上面是有用的==============================
    formItemFocus(){},
    //获取请求筛选数据/分页
    tableRefresh(filter, cal) {
      this.filtersData = filter;
      this.pagerConfig.page = filter.page;
      this.pagerConfig.limit = filter.limit;
      //this.getData(cal);
    },
    updateColumn(columns) {
      //console.log(columns);
    },
    selectAllEvent({ checked, records, selection }) {
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    // 禁用表格复选框
    checkboxMethod({row}) {
      return true;
      //return row.discernStatus == '80130003';
    },
    toBatchInboundDetail(){
      this.optParam = {
        storageId: this.storageId,
        storageName: this.storageName,
        opt: "add",
        itemList: this.itemList,
        itemMap: this.itemMap,
        batchType:"out",
      };
      this.$refs.batchOutboundDetail.visible = true;
      this.$refs.batchOutboundDetail.optParam = this.optParam;
      this.$refs.batchOutboundDetail.init();
    },
    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts'])
  }
};
</script>
<style lang="scss">
  .content {
    padding: 20px;
    height: 200px; /* 每个内容块的高度 */
    border: 1px solid #ccc;
  }
</style>
